const MESSAGES = {
  roundStart: (round: number) =>
    `Раунд ${round}. `,

  orbitalInstruction:
    "Запиши в ячейках адреса комнат гостей",

  adressInstruction:
    "Найдите всех персонажей по адресу",

  selectRoom: "Выбери комнату",

  wrongChoice: "Неверный выбор",

  correctCharacter: "Верный персонаж!",

  emptyFields: "Есть незаполненные поля",

  hasErrors: "Есть ошибки",

  roundSuccess: "Раунд пройден! Нажми Далее",

  gameFinished: (attempts: number) =>
    `Игра пройдена! Было использовано ${attempts} попыток`,
};
export default MESSAGES;